export default {
  optionalAddress: {
    addressLine1: {
      required: false,
      min: 0,
      max: 30,
    },
    addressLine2: {
      required: false,
      min: 0,
      max: 30,
    },
    cityName: {
      required: false,
      min: 0,
      max: 30,
    },
    stateCode: {
      required: false,
      min: 0,
      max: 2,
    },
    zipCode: {
      required: false,
      min: 0,
      max: 5,
    },
  },
  optionalCommonValue: {
    required: false,
    min: 0,
    max: 50,
  },

};
